import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SpotPage } from './spot.page';
import { DaySpotChartComponent } from './charts/day-spot-chart/day-spot-chart.component';
import { HourSpotChartComponent } from './charts/hour-spot-chart/hour-spot-chart.component';
import { ComponentsModule } from 'src/app/shared/components.module';
import { DaySpotTableComponent } from './tables/day-spot-table/day-spot-table.component';
import { HourSpotTableComponent } from './tables/hour-spot-table/hour-spot-table.component';
import { RouterModule } from '@angular/router';
import { routes } from './spot.routes';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentsModule
  ],
  declarations: [
    SpotPage,
    DaySpotChartComponent,
    HourSpotChartComponent,
    DaySpotTableComponent,
    HourSpotTableComponent
  ]
})
export class SpotPageModule {}
